module.exports = __webpack_public_path__ + "img/6.6ac30973.jpg";